module.exports = __webpack_public_path__ + "static/img/action-2fa.85d348f.svg";